import React from "react";

import CreateReportButton from "./CreateReportButton";
import TemplateSearch from "./TemplateSearch";

import { ReactComponent as BackIcon } from "../../../../../assets/images/common/LeftArrowRounded.svg";
import { ReactComponent as RectangleLine } from "../../../../../assets/images/sample-submission/RectangleLine.svg";
import "../styles/common/header.css";

export default function Header(props) {
  const {
    title,
    subtitle,
    showAccent,
    handleAddCoa,
    isCreatingCoa,
    showCreateReportButton,
    handleNavigation,
    apiSearchCoas,
    showAddIcon,
    coaView,
  } = props;

  return (
    <div className="headerContainer">
      <div className="headerTitle">
        {subtitle && showAccent && <RectangleLine aria-hidden />}
        <div>
          <div className="headerTitle_Desc">
            {isCreatingCoa && (<BackIcon className="TemplateHeader__BackIcon" role="button" title="back" onClick={handleNavigation} />)}
            <div className={subtitle ? "HeaderTitle__Text" : (coaView ? "HeaderTitle__Subtitle__COA" : "HeaderTitle__Subtitle")}>{title}</div>
          </div>
          {subtitle && <p className="HeaderTitle__Description">{subtitle}</p>}
        </div>
      </div>
      {showCreateReportButton && isCreatingCoa
        && (
        <div className="headerRight">
          <div className="searchContainer">
            <TemplateSearch handleSearch={apiSearchCoas} />
          </div>
        </div>
        )}
      {showCreateReportButton && !isCreatingCoa
        && (
        <div className="searchContainer">
          <CreateReportButton handleAddCoa={handleAddCoa} buttonText="Create Custom Report" showAddIcon={showAddIcon} />
          <TemplateSearch handleSearch={apiSearchCoas} />
        </div>
        )}

    </div>
  );
}
